module.exports = __webpack_public_path__ + "static/nzctlogo-f6a31a7989cc1ccc8faba9fda7146004.png";